import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChevronLeft, ChevronRight } from 'lucide-react';
export function Pagination({ page, totalPages, onChange }) {
    if (totalPages <= 1)
        return null;
    return (_jsxs("div", { className: "flex items-center justify-between mt-4", children: [_jsxs("p", { className: "text-[13px] text-gray-400", children: ["Page ", _jsx("span", { className: "font-medium text-gray-600", children: page }), " sur ", totalPages] }), _jsxs("div", { className: "flex items-center gap-1", children: [_jsx("button", { onClick: () => onChange(page - 1), disabled: page <= 1, className: "w-8 h-8 flex items-center justify-center rounded-lg border border-gray-200 text-gray-500 disabled:opacity-30 hover:bg-gray-50 transition-colors", children: _jsx(ChevronLeft, { size: 16 }) }), Array.from({ length: Math.min(totalPages, 5) }, (_, i) => {
                        let p;
                        if (totalPages <= 5) {
                            p = i + 1;
                        }
                        else if (page <= 3) {
                            p = i + 1;
                        }
                        else if (page >= totalPages - 2) {
                            p = totalPages - 4 + i;
                        }
                        else {
                            p = page - 2 + i;
                        }
                        return (_jsx("button", { onClick: () => onChange(p), className: `w-8 h-8 flex items-center justify-center rounded-lg text-[13px] font-medium transition-colors ${p === page
                                ? 'bg-blue-600 text-white shadow-sm'
                                : 'text-gray-500 hover:bg-gray-100'}`, children: p }, p));
                    }), _jsx("button", { onClick: () => onChange(page + 1), disabled: page >= totalPages, className: "w-8 h-8 flex items-center justify-center rounded-lg border border-gray-200 text-gray-500 disabled:opacity-30 hover:bg-gray-50 transition-colors", children: _jsx(ChevronRight, { size: 16 }) })] })] }));
}
